<template>
  <v-container class="d-flex align-stretch flex-wrap fill-height align-self-auto">
    <v-row class="d-flex justify-center align-content-center" v-if="true">
      <h1 class="text-center">  App Sinistros </h1>
    </v-row>
    <v-row v-if="false">
      <v-col>
        <graficos />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import Dashboard from '@/views/Dashboard/dash1'
import Graficos from './Graficos/Graficos'

export default {
    name: 'Home',
    components: { Dashboard, Graficos },
    data () {
      return {
        adm: true
      }
    }
  
}
</script>

<style scoped>

  .home {
    align-self: center!important;
  }

  .small {
    max-width: 600px;
    margin: 10px auto;
  }

</style>


// WEBPACK FOOTER //
// src/views/Comum/Home.vue